const ivaTaxReducer = (state = { list : [], selected: null }, action) => {
  switch (action.type) {
    case "GET_IVA_TAX_SUCCESS":
      return { ...state, list: action.payload }
    default:
      return state
  }
}

export default ivaTaxReducer
